import { firebaseDatabase } from '../config/firebase';

const db = firebaseDatabase.ref("polls");

export const getPolls = (limit = 10) => {

  return new Promise(resolve => {
      
      db
      .limitToLast(limit)
      .once('value', async data => {

          let listPolls = [];
  
          data.forEach(doc => {
            let poll = doc.val();
            poll.key = doc.key;
            listPolls.push(poll);
          });
  
          resolve(listPolls.reverse());
        });
    });
}


export const CreateNewPoll = (data)=> {

  return new Promise((resolve, reject)=> {
    db.push()
      .set(data)
      .then(() => {
        resolve({code: "ok"})
      }).catch(e => {
        console.log(e);
        reject(e);
      });
  })
}